import React, { Component } from "react";
import LdsButton from "../components/LdsButton";
import Wrench from "../assets/wrench.svg";


class NotFound extends Component {
  render() {
    return (
        <main className="maintenance">
        <section className="section">
            <div className="container justify-content-center">
                <img src={Wrench} className="mx-auto d-block mb-5"/>
                <p className="xl-text blue trade b text-center mb-5 text-uppercase mt-5" style={{lineHeight: "7rem"}}>
                    we are doing<br/>maintenance
                </p>
                <p className="text-center h2 black text-uppercase mt-5 mb-5 b">
                    Lets get you back on track
                </p>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <LdsButton classes="orange-button next ms-5" onClick={function navClick(){window.open("/","_self")}}>
                            Go to Homepage
                        </LdsButton>
                
                        <LdsButton classes="orange-button ms-5 next" onClick={function navClick(){window.open("/module-1/overview","_self")}}>
                            Start your training
                        </LdsButton>
                    </div>
                </div>
            </div>
        </section>
    </main>
    );
  }
}

export default NotFound;


 

      
    



    
    